import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {NameValueDTO} from 'src/app/modules/common/models/NameValueDTO';
import {DrugInteractionDTO} from 'src/app/modules/pbm/models/DrugInteractionDTO';
import {MatStepper} from '@angular/material/stepper';
import {KeycloakService} from 'keycloak-angular';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {HelpService} from 'src/app/modules/other/services/help.service';
import {DrugInteractionService} from 'src/app/modules/pbm/services/drug-interaction.service';
import {HelpDTO} from 'src/app/modules/other/models/HelpDTO';
import {throwError} from 'rxjs';
import {DrugInteractionCategoryService} from 'src/app/modules/pbm/services/drug-interaction-category.service';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {DrugInteractionCategoryDTO} from 'src/app/modules/pbm/models/DrugInteractionCategoryDTO';
import {ConfirmationDialogComponent} from '../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {createFieldMap} from '../../../../common/util/Util';
import {SharedService} from '../../../../common/services/shared-service';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {LookupValue} from '../../../../clm/types/lookup-value.enum';

enum CategorySource {
  AddNewcategory,
  CategoryA,
  CategoryB,
  Reset = 99
}

@Component({
  selector: 'app-add-drug-interaction-view',
  templateUrl: './add-drug-interaction-view.component.html',
  styleUrls: [
    './add-drug-interaction-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class AddDrugInteractionViewComponent implements OnInit, AfterViewChecked {
  readonly lookupValue = LookupValue;

  addCategoryNameFormControl: FormControl;
  atcCodeFormControl: FormControl;

  categoryNameAFormControl: FormControl;
  categoryNameBFormControl: FormControl;
  severityFormControl: FormControl;
  onsetFormControl: FormControl;
  managementFormControl: FormControl;
  documentationFormControl: FormControl;

  addCategoryFormGroup: FormGroup;
  setInteractionFormGroup: FormGroup;

  documentations: NameValueDTO[];
  managements: NameValueDTO[];
  onsets: NameValueDTO[];
  severities: NameValueDTO[];
  helpInfo: HelpDTO[];
  drugInteractionCategories: DrugInteractionCategoryDTO[];
  allAtcCodes: NameValueDTO[];
  filteredAtcCodes: NameValueDTO[] = [];

  userFirstLastName = '';
  editDrugInteraction = new DrugInteractionDTO();
  isEdit = false;
  isCategoryEdit = false;
  selectedCategoryNew = new DrugInteractionCategoryDTO();
  selectedCategoryA = new DrugInteractionCategoryDTO();
  selectedCategoryB = new DrugInteractionCategoryDTO();
  saveCategoryText = 'Add';

  @ViewChild('stepper') private drugInteractionStepper: MatStepper;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private keycloakService: KeycloakService,
    private lookupService: LookupService,
    private sharedService: SharedService,
    private drugInteractionService: DrugInteractionService,
    private drugInteractionCategoryService: DrugInteractionCategoryService,
    private helpService: HelpService
  ) {
    this.addCategoryNameFormControl = new FormControl('');
    this.atcCodeFormControl = new FormControl('');

    this.categoryNameAFormControl = new FormControl('');
    this.categoryNameBFormControl = new FormControl('');
    this.severityFormControl = new FormControl('');
    this.onsetFormControl = new FormControl('');
    this.managementFormControl = new FormControl('');
    this.documentationFormControl = new FormControl('');

    this.addCategoryFormGroup = this.formBuilder.group({
      addCategoryName: this.addCategoryNameFormControl,
      atcCode: this.atcCodeFormControl,
      atcCodes: this.formBuilder.array(
        [])
    });

    this.setInteractionFormGroup = this.formBuilder.group({
      categoryNameA: this.categoryNameAFormControl,
      categoryNameB: this.categoryNameBFormControl,
      severity: this.severityFormControl,
      onset: this.onsetFormControl,
      management: this.managementFormControl,
      documentation: this.documentationFormControl
    });
  }

  get atcCodes() {
    return this.addCategoryFormGroup.get('atcCodes') as FormArray;
  }

  ngOnInit(): void {
    if (this.route.snapshot.url[1].path === 'edit-drug-interaction') {
      this.isEdit = true;
      this.route.paramMap.subscribe((params) => {
        this.getDrugInteraction(Number(params.get('id')));
      });
    }

    this.getListOfLookupValues(this.lookupValue.InteractionDocumentation);
    this.getListOfLookupValues(this.lookupValue.InteractionManagement);
    this.getListOfLookupValues(this.lookupValue.InteractionOnset);
    this.getListOfLookupValues(this.lookupValue.InteractionSeverity);
    this.getListOfLookupValues(this.lookupValue.Atc);

    this.getHelpInfo('drug_interaction');

    this.keycloakService.loadUserProfile().then((profile) => {
      this.userFirstLastName = `${profile.firstName} ${profile.lastName}`;
    });

    this.getFilteredListOfDrugInteractionCategories(CategorySource.AddNewcategory, false);
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  getDrugInteraction(drugInteractionId: number) {
    this.drugInteractionService.getDrugInteraction(drugInteractionId).subscribe(
      (response) => {
        this.editDrugInteraction = response;
        this.getDrugInteractionCategoryA(this.editDrugInteraction.drugInteractionCategoryA.value);
        this.getDrugInteractionCategoryB(this.editDrugInteraction.drugInteractionCategoryB.value);
        this.populateForms();
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getDrugInteractionCategoryA(categoryId: number) {
    this.drugInteractionCategoryService.getDrugInteractionCategory(categoryId).subscribe(
      (response) => {
        this.selectedCategoryA = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getDrugInteractionCategoryB(categoryId: number) {
    this.drugInteractionCategoryService.getDrugInteractionCategory(categoryId).subscribe(
      (response) => {
        this.selectedCategoryB = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  populateForms() {
    this.categoryNameAFormControl.setValue(this.editDrugInteraction.drugInteractionCategoryA.name);
    this.categoryNameBFormControl.setValue(this.editDrugInteraction.drugInteractionCategoryB.name);
    this.documentationFormControl.setValue(this.editDrugInteraction.documentation.name);
    this.managementFormControl.setValue(this.editDrugInteraction.management.name);
    this.onsetFormControl.setValue(this.editDrugInteraction.onset.name);
    this.severityFormControl.setValue(this.editDrugInteraction.severity.name);
  }

  getListOfLookupValues(entity: string): void {
    this.lookupService.getListOfLookupValues(entity).subscribe(
      (response: NameValueDTO[]) => {
        if (entity === this.lookupValue.InteractionDocumentation) {
          this.documentations = response;
        }
        else if (entity === this.lookupValue.InteractionManagement) {
          this.managements = response;
        }
        else if (entity === this.lookupValue.InteractionOnset) {
          this.onsets = response;
        }
        else if (entity === this.lookupValue.InteractionSeverity) {
          this.severities = response;
        }
        else if (entity === this.lookupValue.Atc) {
          this.allAtcCodes = response;
        }
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getHelpInfo(componentName: string) {
    this.helpService.getListOfHelpInfo(componentName).subscribe(
      (response) => {
        this.helpInfo = response;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  getInfoTooltip(inputName: string): string {
    let message = '';
    if (this.helpInfo != null) {
      const helpInfo = this.helpInfo.find((help) => help.inputName === inputName);
      message = helpInfo != null ? helpInfo.inputInfo : '';
    }
    return message;
  }

  filterAtcCodes() {
    const filterValue = this.atcCodeFormControl.value.toLowerCase();

    if (filterValue.length > 0) {
      this.filteredAtcCodes = this.allAtcCodes
        .filter((option) => option.name.toLowerCase().indexOf(filterValue) >= 0)
        .slice(0, 99);
    }
  }

  addAtcCode() {
    if (
      this.filteredAtcCodes.find(
        (item) => item.name === this.atcCodeFormControl.value
      ) != null
    ) {
      const atcCode = new FormControl(this.atcCodeFormControl.value);
      this.atcCodes.push(atcCode);
    }

    this.atcCodeFormControl.setValue('');
    this.filterAtcCodes();
  }

  removeAtcCode(index: number) {
    this.atcCodes.removeAt(index);
  }

  getFilteredListOfDrugInteractionCategories(source: number, isFilter: boolean = true): void {
    let filterText = '';
    if (source == CategorySource.AddNewcategory) {
      this.saveCategoryText = 'Add';
      this.isCategoryEdit = false;
      filterText = this.addCategoryNameFormControl.value;
    }
    else if (source == CategorySource.CategoryA) {
      filterText = this.categoryNameAFormControl.value;
    }
    else if (source == CategorySource.CategoryB) {
      filterText = this.categoryNameBFormControl.value;
    }

    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblDrugInteractionCategory;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 25;

    if (isFilter) {
      pagedRequestDTO.fieldMap = createFieldMap('name', filterText);
    }

    this.drugInteractionCategoryService.getListOfDrugInteractionCategories(pagedRequestDTO).subscribe(
      (response) => {
        this.drugInteractionCategories = response.resultList;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  drugInteractionCategorySelected(category: DrugInteractionCategoryDTO) {
    this.atcCodes.clear();
    this.drugInteractionCategoryService.getDrugInteractionCategory(category.drugInteractionCategoryId).subscribe(
      (response) => {
        this.selectedCategoryNew = response;
        this.selectedCategoryNew.atcCodes.forEach((atc) => {
          this.atcCodes.push(new FormControl(atc.name));
        });
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );

    this.saveCategoryText = 'Update';
    this.isCategoryEdit = true;
    this.getFilteredListOfDrugInteractionCategories(CategorySource.Reset);
  }

  drugInteractionCategoryASelected(category: DrugInteractionCategoryDTO) {
    this.getDrugInteractionCategoryA(category.drugInteractionCategoryId);
    this.getFilteredListOfDrugInteractionCategories(CategorySource.Reset);
  }

  drugInteractionCategoryBSelected(category: DrugInteractionCategoryDTO) {
    this.getDrugInteractionCategoryB(category.drugInteractionCategoryId);
    this.getFilteredListOfDrugInteractionCategories(CategorySource.Reset);
  }

  resetCategoryForm() {
    this.addCategoryNameFormControl.reset();
    this.atcCodeFormControl.reset();
    this.isCategoryEdit = false;
    this.saveCategoryText = 'Add';
    this.selectedCategoryNew = null;
    this.getFilteredListOfDrugInteractionCategories(CategorySource.Reset);
    this.atcCodes.clear();
  }

  deleteCategory() {
    const id = this.selectedCategoryNew.drugInteractionCategoryId;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.drugInteractionCategoryService.deleteDrugInteractionCategory(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Drug Interaction Category ${id} deleted`, 'Dismiss');
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  saveCategory() {

    if (this.atcCodes.length > 0 && this.addCategoryNameFormControl.value != '') {
      const categoryDTO = new DrugInteractionCategoryDTO();

      categoryDTO.name = this.selectedCategoryNew.name == null ? this.addCategoryNameFormControl.value : this.selectedCategoryNew.name;

      const newAtcCodes: NameValueDTO[] = [];
      this.atcCodes.controls.forEach((control) => {
        newAtcCodes.push({
          value: this.allAtcCodes.find((item) => item.name === control.value)
            .value,
          name: control.value
        });
      });
      categoryDTO.atcCodes = newAtcCodes;

      if (this.isCategoryEdit) {
        categoryDTO.drugInteractionCategoryId = this.selectedCategoryNew.drugInteractionCategoryId;
        categoryDTO.synonym = this.selectedCategoryNew.synonym;
        categoryDTO.updated = new Date();
        categoryDTO.updatedBy = this.userFirstLastName;
        categoryDTO.created = this.editDrugInteraction.created;
        categoryDTO.createdBy = this.editDrugInteraction.createdBy;
      }
      else {
        categoryDTO.created = new Date();
        categoryDTO.createdBy = this.userFirstLastName;
      }

      try {
        this.drugInteractionCategoryService.saveDrugInteractionCategory(categoryDTO).subscribe(
          (response) => {
            this.sharedService.openSnackBar(
              `Category ${this.addCategoryNameFormControl.value} saved successfully`,
              'Dismiss'
            );
            this.resetCategoryForm();
          },
          (error) => {
            throwError(error);
          }
        );
      } catch (e) {
        this.sharedService.openErrorDialog((e as Error).message);
      }
    }
    else {
      this.sharedService.openErrorDialog('The category must have a name and there must be at least 1 linked ATC code');
    }
  }

  finish() {
    const drugInteractionDTO = new DrugInteractionDTO();
    try {
      drugInteractionDTO.drugInteractionCategoryA = {
        value: this.selectedCategoryA.drugInteractionCategoryId,
        name: this.selectedCategoryA.name
      }; // this.selectedCategoryA.toNameValueDTO(); //TODO:Fix this
      drugInteractionDTO.drugInteractionCategoryB = {
        value: this.selectedCategoryB.drugInteractionCategoryId,
        name: this.selectedCategoryB.name
      }; // this.selectedCategoryB.toNameValueDTO();
      drugInteractionDTO.documentation = this.documentations.find(
        (item) => item.name === this.documentationFormControl.value
      );
      drugInteractionDTO.management = this.managements.find(
        (item) => item.name === this.managementFormControl.value
      );
      drugInteractionDTO.onset = this.onsets.find(
        (item) => item.name === this.onsetFormControl.value
      );
      drugInteractionDTO.severity = this.severities.find(
        (item) => item.name === this.severityFormControl.value
      );

      if (this.isEdit) {
        drugInteractionDTO.interactionId = this.editDrugInteraction.interactionId;
        drugInteractionDTO.updated = new Date();
        drugInteractionDTO.updatedBy = this.userFirstLastName;
        drugInteractionDTO.created = this.editDrugInteraction.created;
        drugInteractionDTO.createdBy = this.editDrugInteraction.createdBy;
      }
      else {
        drugInteractionDTO.created = new Date();
        drugInteractionDTO.createdBy = this.userFirstLastName;
      }

      this.drugInteractionService.saveDrugInteraction(drugInteractionDTO).subscribe(
        (response) => {
          this.sharedService.openSnackBar(
            `Drug interaction ${drugInteractionDTO.drugInteractionCategoryA.value} - ${drugInteractionDTO.drugInteractionCategoryB.value} saved successfully`,
            'Dismiss'
          );
          this.router.navigate(['/pharmacy-management'], {queryParams: {tab: 'drug-interactions'}});
        },
        (error) => {
          throwError(error);
        }
      );
    } catch (e) {
      this.sharedService.openErrorDialog((e as Error).message);
      this.drugInteractionStepper.selectedIndex = 0;
    }
  }

  openGenericDialog(displayHeading: string): void {
    const displayList: string[] = [];

    if (displayHeading === 'ATC Codes for Category A') {
      const atcList = this.selectedCategoryA.atcCodes;
      for (let i = 0; i < atcList.length; i++) {
        const displayString = atcList[i].name;
        displayList.push(displayString);
      }
    }
    else if (displayHeading === 'ATC Codes for Category B') {
      const atcList = this.selectedCategoryB.atcCodes;
      for (let i = 0; i < atcList.length; i++) {
        const displayString = atcList[i].name;
        displayList.push(displayString);
      }
    }

    const dialogRef = this.dialog.open(GenericListDialogComponent, {
      width: '40vw',
      maxHeight: '50vh',
      data: {list: displayList, heading: displayHeading}
    });
  }

}
